<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <header class="header"> 
        <h1>Sapori miei <i class="fas fa-utensils"></i></h1>
    </header>
</template>

<script>
export default {
}
</script>

<style scoped>
.header {
    color: var(--text-color);
    background-color: var(--header-color);
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100vw;
    height: 60px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
}

.header h1{
    position: absolute;
    width: 100%;
    
}
</style>